import {Box,Grid,Button,Paper,MenuItem,TextField,Breadcrumbs,Link,Typography, Menu} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useItemAdjustmentReportList } from "api/hooks/reports";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { PDFDownloadLink } from "@react-pdf/renderer";
import StockAdjustmentReportPdf from "scenes/reports/pdfForms/inventory/stockAdjustmentReportPdf";
import { currencyFormatter } from "utilities/currencyFormatter";

export default function StockAdjustmentReport({ setIsSuccess }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const user = useSelector((state) => state.authReducer.user);
  const {itemAdjustmentReportList, isLoadingItemAdjustmentReportList, setFilter} = useItemAdjustmentReportList(1, business_branch_id);

  const [openExportOptions, setOpenExportOptions] = useState(false);
  const [anchorE1, setAnchorE1] = useState(null);

  const handleClickOpen = (event) => {
    setAnchorE1(event.currentTarget);
    setOpenExportOptions(true);
  };

  const handleClose = () => {
    setOpenExportOptions(false);
  };

  // const handleChangeSupplierFilter = async (e) => {
  //   setSupplier(e.target.value);
  // };

  const [showFiter, setShowFilter] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));

  let report_period = startDate + " to " + endDate

  const handleChangePeriodFilter = async (e) => {
    if (e.target.value === "THIS MONTH") {
      setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("month").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "THIS WEEK") {
      setStartDate(moment().startOf("week").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("week").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "TODAY") {
      setStartDate(moment().format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "CUSTOM") {
      setShowFilter(true);
    }
  };

  const handleClickFilter = () => {
    setFilter({ start: startDate, end: endDate });
  };

  const columns = [
    { label: "Date Created" },
    { label: "Item", width: 300 },
    { label: "Description", width: 300 },
    { label: "Quantity", align: "center" },
    { label: "Batch", align: "center" },
    { label: "Adjustment Type" },
    { label: "Adjustment Value" },
    { label: "Created By" },
  ];

  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Stock Adjustment Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={4}>
              {/* <Paper
                sx={{
                  my: "4px",
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  minWidth: 170,
                  maxWidth: 300,
                }}
              >
                <InputBase
                  placeholder="Search Item Name"
                  value={searchContent}
                  onChange={handleSearchInput}
                  sx={{ ml: 1, flex: 1 }}
                />
                <IconButton onClick={handleClickSearch}>
                  <SearchIcon />
                </IconButton>
              </Paper> */}
            </Grid>

            <Grid xs={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>REPORT PERIOD:</h4>
                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                  }}
                >
                  <TextField
                    label="PERIOD"
                    select
                    defaultValue="THIS MONTH"
                    size="small"
                    onChange={(e) => {
                      handleChangePeriodFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width:'100%'
                      // m: "10px",
                      // backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="TODAY">TODAY</MenuItem>
                    <MenuItem value="THIS WEEK">THIS WEEK</MenuItem>
                    <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                    <MenuItem value="CUSTOM">CUSTOM</MenuItem>
                  </TextField>
                </Paper>
                
                {showFiter ? (
                  <>
                    <Paper
                      sx={{
                        m: "10px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                      }}
                    >
                      <TextField
                        label="Start Date"
                        type="date"
                        defaultValue={startDate}
                        size="small"
                        onChange={(e) => setStartDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          max: endDate,
                        }}
                      />
                    </Paper>
                    
                    <Paper
                      sx={{
                        m: "10px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                      }}
                    >
                      <TextField
                        label="End Date"
                        type="date"
                        defaultValue={endDate}
                        size="small"
                        onChange={(e) => setEndDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          min: startDate,
                        }}
                      />
                    </Paper>
                    
                  </>
                ) : null}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    m: "9px",
                  }}
                  onClick={() => handleClickFilter()}
                >
                  FILTER
                </Button>
              </Box>
            </Grid>
            <Grid xs={2} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                anchorE1={anchorE1}
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
              <Menu
                style={{ marginRight: "30px" }}
                anchorEl={anchorE1}
                open={openExportOptions}
                onClose={handleClose}
              >
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  <PDFDownloadLink document={<StockAdjustmentReportPdf viewData={{ report_detail: itemAdjustmentReportList, report_period: report_period}}  printedBy={user.first_name + ' ' + user.last_name}/>} fileName={`Stock Adjustment Report for ${report_period}`}>
                    PDF
                  </PDFDownloadLink>
                </MenuItem>    
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  EXCEL
                </MenuItem>  
              </Menu>
            </Grid>
          </Grid>
        </Box>

        <ReportTable
          columns={columns}
          rows={itemAdjustmentReportList}
          loading={isLoadingItemAdjustmentReportList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id ?? index} index={index}>
              <RCell>{moment(row.related_adjustment.date_added).format("LLL")}</RCell>
              <RCell>{row.related_product.product_name}</RCell>
              <RCell>{row.related_product.description}</RCell>
              <RCell align="center">{row.quantity}</RCell>
              <RCell align="center">{row.batch}</RCell>
              <RCell>{row.adjustment_type}</RCell>
              <RCell>{currencyFormatter(parseFloat(row.amount))}</RCell>
              <RCell>{row.related_adjustment.added_by.first_name} {row.related_adjustment.added_by.last_name}</RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
